import { Pipe, type PipeTransform } from '@angular/core';
import { Key } from '../types/shared';

@Pipe({
  name: 'isArray',
})
export class CheckIsArrayPipe implements PipeTransform {
  transform(value: unknown): boolean {
    return Array.isArray(value);
  }
}

@Pipe({
  name: 'in',
})
export class CheckInArrayPipe implements PipeTransform {
  transform<T>(value: T, array: readonly T[]): boolean {
    return Array.isArray(array) ? array.includes(value) : false;
  }
}

@Pipe({
  name: 'at',
})
export class AtIndexArrayPipe implements PipeTransform {
  transform<T>(array: readonly T[], index: number): T {
    return Array.isArray(array) ? array.at(index) : undefined;
  }
}

@Pipe({
  name: 'indexOf',
})
export class IndexOfArrayPipe implements PipeTransform {
  transform<T>(array: T[], elem: T): number {
    return Array.isArray(array) ? array.indexOf(elem) : undefined;
  }
}

@Pipe({
  name: 'find',
})
export class FindInArrayPipe implements PipeTransform {
  transform<T>(array: readonly T[], key: Key<T>, value: T[Key<T>]): T {
    return Array.isArray(array) ? array.find(elem => elem[key] == value) : undefined;
  }
}
